export default {
  title: 'Parceiros',
  search_placeholder: 'Pesquisar parceiro...',
  buttons: {
    default_price_list: 'Lista de preços predefinida',
    create_partner: 'Criar parceiro',
  },
  columns: {
    name: 'Nome',
    restaurants: 'Restaurantes',
    shop_domain: 'Domínio da loja',
    status: 'Estado',
    earning_enabled: 'Ganhos ativados',
  },
  statuses: {
    invited: 'Convidado',
    active: 'Ativo',
    suspended: 'Suspenso',
  },
  actions: {
    edit: 'Editar',
    view_billing: 'Ver faturação',
    view_as_partner: 'Ver como parceiro',
    suspend: 'Suspender',
    unsuspend: 'Reativar',
  },
  suspension: {
    suspend_title: 'Suspender este parceiro?',
    suspend_description:
      'Todos os membros da equipa do parceiro serão desativados e as sessões revogadas. Os seus restaurantes continuam ativos.',
    unsuspend_title: 'Reativar este parceiro?',
    unsuspend_description:
      'Todos os membros da equipa do parceiro serão reativados e poderão iniciar sessão novamente.',
  },
  toasts: {
    load_error: 'Não foi possível carregar os parceiros.',
    suspended: 'O parceiro foi suspenso.',
    unsuspended: 'O parceiro foi reativado.',
    suspension_error: 'Não foi possível alterar o estado do parceiro.',
    view_as_error: 'Não foi possível abrir o painel do parceiro.',
  },
};
